import type { NavMainProps } from './main/nav/types';

import { paths } from 'src/routes/paths';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export const navData: NavMainProps['data'] = [
  {
    title: 'Content',
    path: paths.dashboard.post.root,
    icon: <Iconify width={22} icon="solar:file-bold-duotone" />,
  },
];
